export default __webpack_public_path__ + "static/media/home-outline.a99e2719.svg";